import { render, staticRenderFns } from "./TermosForm.vue?vue&type=template&id=1071ca0c&"
import script from "./TermosForm.vue?vue&type=script&lang=js&"
export * from "./TermosForm.vue?vue&type=script&lang=js&"
import style0 from "./TermosForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports